import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import Walkthrough from "@/components/learn/Walkthrough";

// Offers the narrated walkthrough on first sign-in; replayable from the Learning Centre.
export default function WalkthroughGate() {
  const { user, refreshUser } = useAuth();
  const [play, setPlay] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (play) return <Walkthrough onClose={() => { setPlay(false); setDismissed(true); }} />;
  if (user.learn_tour_seen_at || dismissed) return null;
  // Clients first get the welcome card; show the walkthrough offer only once that's done, so they don't get two prompts at once.
  if (user.role === "client" && !user.welcomed_at) return null;

  const later = () => {
    setDismissed(true);
    api.post("/auth/tour-seen").then(() => refreshUser()).catch(() => {});
  };

  return (
    <div className="fixed inset-0 z-[65] grid place-items-center bg-stone-950/60 p-6" data-testid="walkthrough-offer">
      <div className="w-full max-w-md rounded-3xl bg-card p-8 text-center shadow-2xl">
        <p className="eyebrow">A quick welcome</p>
        <h2 className="mt-2 font-serif text-2xl">Take the 2-minute tour?</h2>
        <p className="mt-3 text-sm text-muted-foreground">
          A short narrated walkthrough of E.L.M, set up for {user.role === "client" ? "your project view" : "running a job"}. You can skip, pause or replay it any time from Learn.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button className="rounded-full" onClick={() => setPlay(true)} data-testid="walkthrough-offer-watch">Watch now</Button>
          <Button variant="ghost" className="rounded-full" onClick={later} data-testid="walkthrough-offer-later">Maybe later</Button>
        </div>
      </div>
    </div>
  );
}
